import {PostActivityModel} from '../api/types.ts';
import {GroupPageTabNames} from '../components/groups/GroupPage.tsx';

export default function getPostUrl(activity: PostActivityModel) {
    return `/explore/groups/${activity.collectionContainerName}?tab=${GroupPageTabNames.Posts}&ch=${activity.channelName}&pid=${activity.postId}&ppid=${activity.parentPostId}`;
}
